module.exports = __webpack_public_path__ + "img/pwmat.d91fb330.jpg";